/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_bar_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yes. The chart is responsive and re-colours automatically for light and dark themes.`)
};

const es_bar_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sí. El gráfico es responsivo y cambia de color automáticamente según los temas claro y oscuro.`)
};

const de_bar_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ja. Das Diagramm ist responsiv und passt seine Farben automatisch an helle und dunkle Themen an.`)
};

const nl_bar_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ja. De grafiek is responsief en past de kleuren automatisch aan voor lichte en donkere thema's.`)
};

const fr_bar_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oui. Le graphique est responsive et se recolore automatiquement pour les thèmes clair et sombre.`)
};

const it_bar_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sì. Il grafico è responsive e cambia colore automaticamente per i temi chiaro e scuro.`)
};

const pt_br2_bar_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sim. O gráfico é responsivo e muda de cor automaticamente para os temas claro e escuro.`)
};

const pt_bar_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sim. O gráfico é responsivo e recolore-se automaticamente para os temas claro e escuro.`)
};

const ja_bar_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`はい。グラフはレスポンシブで、ライトテーマとダークテーマに合わせて自動的に配色が変わります。`)
};

const zh_bar_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`支持。图表是响应式的，并会根据浅色和深色主题自动重新配色。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const bar_faq_a3 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.bar_faq_a3(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("bar_faq_a3", locale)
	if (locale === "en") return en_bar_faq_a3(inputs)
	if (locale === "es") return es_bar_faq_a3(inputs)
	if (locale === "de") return de_bar_faq_a3(inputs)
	if (locale === "nl") return nl_bar_faq_a3(inputs)
	if (locale === "fr") return fr_bar_faq_a3(inputs)
	if (locale === "it") return it_bar_faq_a3(inputs)
	if (locale === "pt-BR") return pt_br2_bar_faq_a3(inputs)
	if (locale === "pt") return pt_bar_faq_a3(inputs)
	if (locale === "ja") return ja_bar_faq_a3(inputs)
	return zh_bar_faq_a3(inputs)
};